/* istanbul ignore file */
import { Button } from "@/components/ui/button/button";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@/components/ui/toggle-group/toggle-group";
import { usePersistedState } from "@/lib/usePersistedState";
import { cn } from "@/lib/utils";
import { TriangleAlert } from "lucide-react";
import { useState, useEffect } from "react";
import { devEnvs } from "../../../config.json";

type EnvironmentKey = keyof typeof devEnvs;
const ENVIROMENTS = Object.keys(devEnvs) as EnvironmentKey[];

export function SelectDevEnvironment(props: { className?: string }) {
  const [isOpen, setIsOpen] = useState(false);
  const [environment, setEnvironment] = usePersistedState<EnvironmentKey>(
    "dev_environment",
    ENVIROMENTS[0]
  );
  const [envToUse, setEnvToUse] = useState<EnvironmentKey>(environment);

  const applyAndRefresh = () => {
    setEnvironment(envToUse);
    window.location.reload();
  };

  useEffect(() => {
    setEnvToUse(environment);
  }, [environment]);

  return (
    <div
      className={cn(
        props.className,
        "absolute flex flex-col gap-5 bg-secondary right-0 bottom-0 p-5 m-10 w-[320px] rounded shadow-2xl"
      )}
    >
      <div
        className="text-primary cursor-pointer flex justify-between items-center"
        onClick={() => setIsOpen((s) => !s)}
      >
        <div className="flex">
          <TriangleAlert className="inline mr-3" />
          <span>
            Using <b>{environment}</b> data
          </span>
        </div>
        <div className="text-gray-400 text-xs">
          {isOpen ? "keep" : "change"}
        </div>
      </div>
      {isOpen && (
        <>
          <ToggleGroup
            value={envToUse}
            type="single"
            className="text-primary grid grid-cols-3 [&>*:first-child]:col-span-3"
            onValueChange={(s) => setEnvToUse(s as EnvironmentKey)}
          >
            {ENVIROMENTS.map((env) => (
              <ToggleGroupItem value={env} key={env}>
                {env}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
          <Button disabled={envToUse === environment} onClick={applyAndRefresh}>
            Apply
          </Button>
          <p className="text-primary text-2xs">
            Clicking apply will refresh the app and switch to the chosen data
            source
          </p>
        </>
      )}
    </div>
  );
}
